// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3LE5m","additionalInfo":"AgreementModal_additionalInfo__1QatR"};